import { useState, useEffect } from 'react';
import axios from 'axios';
import { TextField, Button, Select, MenuItem, InputLabel, FormControl, Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import {API_BASE}from '../../utils/api';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";

function AddSubCategory() {
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState('');
    const [subCat, setSubCat] = useState('');
    const [imagePreview, setImagePreview] = useState(null);
    const [image, setImage] = useState(null);
   
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const navigate = useNavigate();
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${API_BASE}/api/categories/all`);
                setCategories(response.data);
            } catch (err) {
                toast.error('Failed to load categories');
            }
        };

        fetchCategories();
    }, []);

    const capitalizeWords = (str) => {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const validTypes = ['image/jpeg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            setErrors({ ...errors, image: 'Only JPG and PNG files are allowed.' });
            setImage(null);
            setImagePreview(null);
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            setErrors({ ...errors, image: 'File size must be less than 5MB.' });
            setImage(null);
            setImagePreview(null);
            return;
        }

        setErrors({ ...errors, image: '' }); 
        setImage(file);
        setImagePreview(URL.createObjectURL(file)); 
    };

    const handleCategoryChange = (e) => setCategory(e.target.value);
    const handleSubCatChange = (e) => {
        const value = e.target.value;
        setSubCat(capitalizeWords(value));
    };
    
    const validateForm = () => {
        const newErrors = {};

        if (!category) {
            newErrors.category = 'Please select a category.';
        }
        if (!subCat.trim()) {
            newErrors.subCat = 'Please enter subcategory name.';
        }
        if (!image) {
            newErrors.image = 'Please upload an image.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        if (!validateForm()) {
            setIsSubmitted(false);
            return;
        }

        try {
            const checkResponse = await axios.get(`${API_BASE}/api/subcategory/check?category=${category}&subCat=${subCat}`);
            const checkData = checkResponse.data;

            if (checkData.exists) {
                toast.warning('Subcategory exists in the selected category!');
                setIsSubmitted(false);
                return;
            }

            const formData = new FormData();
            formData.append('category', category);
            formData.append('subCat', subCat);
            if (image) formData.append('image', image);

            const response = await axios.post(`${API_BASE}/api/subcategory/add-subcategory`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.status === 201) {
                toast.success('Subcategory added!Please enable to see in customer UI from edit screen');
                setCategory('');
                setSubCat('');
                setImage(null);
                setImagePreview(null);
                setErrors({});
                setFileInputKey(Date.now());
                
            } else {
                toast.error('Failed to add subcategory');
            }
        } catch (err) {
            console.error('Error submitting subcategory:', err);
            toast.error('Failed to add subcategory');
        } finally {
            setIsSubmitted(false);
        }
    };

    return (
        <div className="container">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <IconButton
            onClick={() => navigate('/subcategories')}
            className="back-button"
            style={{
              backgroundColor: '#e0e0e0',
              border: '1px solid #ccc',
              borderRadius: '50%',
              padding: '5px',
              color: '#333',
            }}
          >
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
      
          <h5 className="heading">Add Subcategory</h5>
        </div>
     
      
            <form onSubmit={handleSubmit} className='form'>
                <Box mb={3}>
                    <FormControl  style={{ width: "100%" }} variant="filled">
                        <InputLabel>Category </InputLabel>
                        <Select value={category} onChange={handleCategoryChange} disabled={isSubmitted}>
                            {categories.map((cat) => (
                                <MenuItem key={cat._id} value={cat._id}>
                                    {cat.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.category && <p style={{ color: 'red', fontSize: '0.75rem' }}>{errors.category}</p>}
                    </FormControl>
                </Box>
                <Box mb={3}>
                    <TextField
                         style={{ width: "100%"}}
                        variant="filled"
                        label="Subcategory Name"

                        onChange={handleSubCatChange}
                        value={subCat}
                        disabled={isSubmitted}
                    />
                    {errors.subCat && <p style={{ color: 'red', fontSize: '0.75rem' }}>{errors.subCat}</p>}
                </Box>
                <Box mb={3}>
                    <input  key={fileInputKey} 
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleImageChange}
                        disabled={isSubmitted} />
                    {errors.image && <p style={{ color: 'red', fontSize: '0.75rem' }}>{errors.image}</p>}
                    {imagePreview && (
                        <Box mt={2}>
                            <img src={imagePreview} alt="Preview" style={{ width: '150px', height: '150px', objectFit: 'cover', borderRadius: '10px' }} />
                        </Box>
                    )}
                </Box>
                <Box className='button'>
                <Button variant="contained" color="primary" type="submit"  disabled={isSubmitted || !!errors.image}>
                    Save
                </Button></Box>
            </form>
           <ToastContainer position="top-center" autoClose={3000} />
        </div>
    );
}

export default AddSubCategory;
